import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Container,
  Typography
} from '@mui/material';

import { sendRequestForCode, auth } from "../firebase";
import { signOut } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";

import CodeForm from "components/CodeForm";
import PhoneNumberForm from "components/PhoneNumberForm";
import { Spinner } from 'components/Icons';
import { Tracking } from 'components/Tracking';

const db = getDatabase();

export const Login = () => {
  const [authRecognised, setAuthRecognised] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => { 
    Tracking.track('Portal - Login')
  }, [])
  
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        // Firebase authentication is valid
        const user_ref = ref(db, 'users/' + user.uid);
        get(user_ref).then((snapshot) => {
          let user_account = snapshot.val()?.userAccount
          // console.log('snapshot.val()?.userAccount', user_account)
          if (user_account) {
            const account_ref = ref(db, 'accounts/' + user_account);
            get(account_ref).then((snapshot) => {
              const data = snapshot.val();
              // console.log('data.features', data.features)
              if (data.features && data.features.webPortal) {
                // console.log("Yes access to web portal")
                // Tracking.track('Portal - Login Success')
                setIsLoggedIn(true);
                // navigate('/')
              } else {
                console.log("No access to web portal")
                signOut(auth);
                setIsLoggedIn(false);
                setRequestSent(false);
                Tracking.track('Portal - Login Error', { detail: 'no web access' })
                setErrorMessage("Sorry, your FAVES Pro account does not include web access. Please contact support@favespro.com for assistance.")
              }
            })
          } else {
            if (!user || user && requestSent) {
              // console.log('111')
              setAuthRecognised(true);
              setIsLoggedIn(false);
              setRequestSent(false);
              Tracking.track('Portal - Login Error', { detail: 'no web access' })
              setErrorMessage("Sorry, your FAVES Pro account does not include web access. Please contact support@favespro.com for assistance.")
            } else {
              // console.log('222')
              // console.log('requestSent', requestSent)
              // console.log('isLoading', isLoading)
            }
          }
        })

      } else {
        console.log("Just comes here, so should reset")
        setAuthRecognised(true);
        setIsLoading(false);
        setIsLoggedIn(false);
        setRequestSent(false);
      }
    });
    // return () => unsubscribe();
  }, [auth]);

  function handlePhoneNumberForm(phoneNumber) {
    // console.log('login.js - handlePhoneNumberForm')
    setIsLoading(true);

    return sendRequestForCode(phoneNumber)
      .then(() => {
        setRequestSent(true);
        setErrorMessage("");
      }).catch((e) => {
        // console.log('sendRequestForCode error', e)
        Tracking.track('Portal - Login Error', { detail: e, phone: phoneNumber })
        setErrorMessage("An error occurred verifying the phone number associated with this account. Please contact support@favespro.com for assistance.");
      }).finally(() => setIsLoading(false));
  }

  function handleCodeForm(code) {
    // console.log('login.js - handleCodeForm')
    setIsLoading(true);

    const confirmation = window.confirmationResult;

    return confirmation.confirm(code)
      .then((e) => {
        // console.log('login.js - handleCodeForm. then', e)
        const user_ref = ref(db, 'users/' + e.user.uid);
        get(user_ref).then((snapshot) => {
          let user_account = snapshot.val()?.userAccount
          // console.log('login.js - handleCodeForm. useraccount', user_account)
          if (user_account) {
            const account_ref = ref(db, 'accounts/' + user_account);
            get(account_ref).then((snapshot) => {
              const data = snapshot.val();
              if (data.features && !data.features.webPortal) {
                // console.log('login.js - handleCodeForm. should not access')
              } else {
                Tracking.track("Portal - Login Success", { email: e.user.email, uid: e.user.uid })
                // console.log('login.js - handleCodeForm. should access')
              }
            })
          } else {
            // console.log('login.js - handleCodeForm. no user_account. should not access')
            Tracking.track('Portal - Login Error', { detail: 'no account' })
            setRequestSent(false)
            setErrorMessage(`You don't seem to have an account`)
          }
        })
      })
      .catch(() => {
        Tracking.track('Portal - Login Error', { detail: 'incorrect or expired code' })
        setErrorMessage("Sorry, the code you entered is incorrect or expired. Please check the number and try again.");
      })
      .finally((e) => { 
        // console.log('login.js - handleCodeForm. finally', e)
        setIsLoading(false)
      });
  }

  if (isLoggedIn && requestSent) {
    // setRequestSent(false);
    // return <Navigate to="/" />;
    window.location.href = '/'
  }

  if (!authRecognised) {
    return <Spinner/>
  }

  return(
    <>
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component="h1" variant="h5">
            Log in
          </Typography>
          <Box sx={{ mt: 1 }}>
            { errorMessage ? <Alert sx={{ mb: 3 }} severity="warning">{errorMessage}</Alert> : null }
            { requestSent ?
              <CodeForm
                handleForm={handleCodeForm}
                isLoading={isLoading}
              />
              :
              <PhoneNumberForm
                handleForm={handlePhoneNumberForm}
                isLoading={isLoading}
              />
            }
          </Box>
        </Box>
      </Container>
    </>
  )
}